import dictionary_de from './dictionary_de';
import dictionary_en from './dictionary_en';
import dictionary_fr from './dictionary_fr';

export const dict = {
  de: dictionary_de,
  en: dictionary_en,
  fr: dictionary_fr
};

export const localeLangToDictionary = lang => {
  const lg = lang.toLowerCase().split('-')[0];
  return dict[lg] ? lg : dict.en.lang_short;
};

export const getKey = (key, lang) => {
  let currentDict = dict[lang] ? dict[lang] : dict.en;

  // eslint-disable-next-line no-prototype-builtins
  return currentDict.hasOwnProperty(key)
    ? currentDict[key]
    : // eslint-disable-next-line no-prototype-builtins
    dict.en.hasOwnProperty(key)
    ? dict.en[key]
    : key;
};

export const checkDict = () => {
  if (process.env.REACT_APP_ENV !== 'production') {
    const missingValues = checkForMissingValuesInDictionaries(dict);
    if (Object.keys(missingValues).length > 0) {
      console.error(
        'The following values are missing in the dictionary: ',
        Object.keys(missingValues).reduce(
          (current, item) => `${current}\n${missingValues[item]}:  ${item}`,
          ''
        )
      );
    }
  }
};

const checkForMissingValuesInDictionaries = dictionary => {
  let valueSet = new Set();
  let missingValues = {};

  for (let language in dictionary) {
    const dict = dictionary[language];
    for (let item in dict) {
      valueSet.add(item);
    }
  }
  for (const value of valueSet.values()) {
    for (let language in dictionary) {
      const dict = dictionary[language];

      // eslint-disable-next-line no-prototype-builtins
      if (!dict.hasOwnProperty(value)) {
        missingValues[value] = language;
      }
    }
  }
  return missingValues;
};
